import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const PrivacyPolicy = () => {
  return (
    <>
      <Meta title={"Privacy Policy"} />
      <BreadCrumb title="Privacy Policy" />
        <div className="bg-gray-50 min-h-screen py-12 sm:px-8">
      <div className="p-4 max-w-5xl mx-auto bg-white p-10 rounded-2xl shadow-lg">
        <h2 className="text-4xl font-bold text-blue-700 mb-8 text-center">Privacy Policy</h2>
        <p className="text-gray-700 mb-6">
          This Privacy Policy describes how Shoplintic ("we", "our", or "us") collects, uses, and discloses your personal information when you visit or make a purchase from our website located at <strong>shoplintic.in</strong>. We are committed to protecting your privacy and handling your personal data transparently and securely as you shop for fashion and beauty products.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">1. Information We Collect</h4>
        <p className="text-gray-700 mb-4">
          We collect various types of information to enhance your shopping experience with fashion and beauty products. This includes:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li><strong>Personal Information:</strong> When you create an account or place an order, we collect your name, address, email, phone number, and payment details.</li>
          <li><strong>Fashion & Beauty Preferences:</strong> Information about your clothing sizes, style preferences, skin type, hair type, and beauty product preferences to provide personalized recommendations.</li>
          <li><strong>Device Information:</strong> We automatically collect data such as your IP address, browser type, device type, and operating system to help us better understand how users access and navigate our site.</li>
          <li><strong>Usage Information:</strong> Information about how you interact with our website, such as page views, time spent on pages, product views, and clicks on fashion/beauty categories.</li>
          <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to personalize your experience, analyze traffic, and deliver targeted fashion and beauty product recommendations.</li>
        </ul>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">2. How We Use Your Information</h4>
        <p className="text-gray-700 mb-6">
          Your data is used for the following purposes:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li>To process your orders and manage your account for fashion and beauty purchases.</li>
          <li>To communicate with you regarding your order, delivery, or support requests.</li>
          <li>To send promotional offers, newsletters, style tips, beauty advice, and product updates for clothing and cosmetics.</li>
          <li>To provide personalized product recommendations based on your fashion preferences and beauty profile.</li>
          <li>To improve the functionality and performance of our website and enhance your shopping experience.</li>
          <li>To comply with legal obligations and ensure safe delivery of beauty products.</li>
        </ul>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">3. Sharing Your Information</h4>
        <p className="text-gray-700 mb-6">
          We respect your privacy. We do not sell or rent your personal information to third parties. However, we may share data with:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li><strong>Service Providers:</strong> Payment processors, fashion delivery partners, beauty product suppliers, hosting services, and marketing tools who help us operate our website and fulfill your orders for clothing and cosmetics.</li>
          <li><strong>Legal Authorities:</strong> When required by law or to protect our rights, we may disclose information to law enforcement or government bodies.</li>
        </ul>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">4. Cookies and Tracking</h4>
        <p className="text-gray-700 mb-6">
          Cookies are small text files stored on your device to help websites remember your preferences. We use cookies for:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li>Keeping you logged in to your account</li>
          <li>Storing items in your fashion and beauty shopping cart</li>
          <li>Remembering your size preferences and beauty product choices</li>
          <li>Tracking analytics and performance data</li>
          <li>Personalizing content, style recommendations, and beauty product suggestions</li>
        </ul>
        <p className="text-gray-700 mb-6">
          You can disable cookies through your browser settings, but this may affect the functionality of our website and your personalized shopping experience.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">5. Data Security</h4>
        <p className="text-gray-700 mb-6">
          We implement industry-standard security measures including SSL encryption and secure payment gateways to protect your personal data. Access to your data is restricted to authorized personnel only.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">6. Your Rights</h4>
        <p className="text-gray-700 mb-6">
          You have the right to access, modify, or delete your personal data. You can:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-1">
          <li>Request a copy of the information we hold about you</li>
          <li>Update or correct your personal details</li>
          <li>Request deletion of your account and data</li>
          <li>Unsubscribe from marketing emails at any time</li>
        </ul>
        <p className="text-gray-700 mb-6">
          To exercise any of these rights, please contact us at <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a>.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">7. Third-Party Links</h4>
        <p className="text-gray-700 mb-6">
          Our site may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. Please review their policies before submitting personal data.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">8. Children's Privacy</h4>
        <p className="text-gray-700 mb-6">
          Our services are not intended for individuals under the age of 13. We do not knowingly collect personal data from children. If we become aware that a child has provided us with personal information, we will delete it immediately.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">9. International Users</h4>
        <p className="text-gray-700 mb-6">
          If you are accessing our services from outside India, be aware that your information may be transferred to, stored, and processed in India. By using our site, you consent to this transfer and processing.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">10. Changes to This Privacy Policy</h4>
        <p className="text-gray-700 mb-6">
          We may update this policy from time to time to reflect changes in our practices or legal obligations. All updates will be posted on this page with the “Last Updated” date at the bottom.
        </p>

        <h4 className="text-2xl font-semibold text-gray-800 mb-2">11. Contact Us</h4>
        <p className="text-gray-700 mb-6">
          If you have any questions, concerns, or complaints regarding this privacy policy or how we handle your data, please contact us:
        </p>
        <p className="text-gray-700">
          📧 <a href="mailto:support@shoplintic.in" className="text-blue-600 underline">support@shoplintic.in</a><br />
          🌐 Website: <a href="https://shoplintic.in" className="text-blue-600 underline">shoplintic.in</a>
        </p>

        <p className="text-sm text-gray-500 mt-10">Last Updated: June 5, 2025</p>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;
